import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-sell-category',
	templateUrl: './sell-category.component.html',
	styleUrls: ['./sell-category.component.css'],
})
export class SellCategoryComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/sell_category/';
	protected parentComponent = 'codebook/sell_category';
	parentLocationSet = [];
	codebook;
	protected itemsBeforeDataLoad = 2;
	isActiveOptions = [
		{ use: false, name: 'Nie' },
		{ use: true, name: 'Tak' },
	];

	data = {
		id: null,
		name: null,
		use: null,
		fee: null,
	};

	protected pageTitleGenerate(): string {
		return `Słowniki -> 
			${this.codebook.name}
			 -> 
			${this.data.name}
			(ID: 
			${this.data.id}
			)`;
	}
	protected loadBefore(): void {
		this.bag.get('/sell_category/', (result, error) => {
			this.parentLocationSet = result.results;
			this.loadData();
		});
		this.bag.get('/codebook/5/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected getApiUrl(): string {
		return '/sell_category/' + this.data.id + '/';
	}
}
